export interface HeroVideoSlide {
  id: number;
  videoSrc: string;
  posterSrc: string;
  stepNumber: string;
  stepLabel: string;
  tag: string;
  titlePart1: string;
  titleHighlight: string;
  description: string;
}

export const HERO_SLIDES: HeroVideoSlide[] = [
  {
    id: 1,
    videoSrc: "/videos/video1.mp4",
    posterSrc: "/videos/poster1.jpg",
    stepNumber: "01",
    stepLabel: "Revaloriza",
    tag: "Experiencia & Pasión",
    titlePart1: "El próximo LEGO® que sueñas con montar, ",
    titleHighlight: "ya lo tiene tu vecino.",
    description:
      "Siente la emoción de montar los sets más legendarios del mundo por días o semanas, sin pagar su precio completo ni acumular cajas en casa.",
  },
  {
    id: 2,
    videoSrc: "/videos/video2.mp4",
    posterSrc: "/videos/poster2.jpg",
    stepNumber: "02",
    stepLabel: "Alquila",
    tag: "Entrega Inmediata",
    titlePart1: "Sets completos y revisados. ",
    titleHighlight: "Entrega en mano 0 € o envío.",
    description:
      "Recíbelo en tu ciudad o en tu puerta precintado y listo para disfrutar. Vive la magia del unboxing y compártelo cuando termines.",
  },
  {
    id: 3,
    videoSrc: "/videos/video3.mp4",
    posterSrc: "/videos/poster3.jpg",
    stepNumber: "03",
    stepLabel: "Disfruta",
    tag: "Catálogo Infinito",
    titlePart1: "Un santuario infinito de maquetas. ",
    titleHighlight: "Alquila o comparte los tuyos.",
    description:
      "Descubre joyas descatalogadas y las últimas novedades oficiales en tu ciudad o pon tus propios sets a generar ingresos.",
  },
];
